import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {toggleFavorite, submitQuestion} from '../actions/race';

class Question extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      name: '',
      email: '',
      gender: 'Male',
      age: '',
      city: '',
      state: '',
      bib: '',
      clock: '',
      finish: '',
      chip: '',
      question: '',
     error: null,
      success: '',
      showForm: true
    };

  }

  toggleFavorite(leader, fav) {
    this.props.toggleFavorite(leader, fav);
  }

  navigateToRunner(runner) {
    this.props.history.push(`/race/${this.props.raceDetail.race_id}/${this.props.eventId}/${runner.$KEY}`);
  }

  handleOnChange(field, e) {
    const newState = Object.assign({}, this.state);
    newState[field] = e.target.value;

    this.setState(newState);
  }


  handleQuestionSubmit(e) {
    e.preventDefault();
    // console.log(e);

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const {name, email, gender, age, city, state, bib, clock, finish, chip, question} = this.state;

    if (name === '' || email === '' || gender === '' || age === '' || city === '' || finish === '' || question === '') {
      this.setState({error: 'Please fill out all required (*) form fields.', success: '', showForm: true})
    } else if (!email.match(re)) {
      this.setState({error: 'Please include a valid email address.', success: '', showForm: true});
    } else {
      this.props.submitQuestion({question_name: name, question_email: email, gender, age, city, state, bib, clock, finish, chip, question});
      this.setState({
        name: '',
        email: '',
        gender: 'Male',
        age: '',
        city: '',
        state: '',
        bib: '',
        clock: '',
        finish: '',
        chip: '',
        question: '',
        error: null,
        success: 'Question has successfully been submitted.',
        showForm: false
      })
    }

  }

  render() {

    const ColorThemeHoverSpan = styled.span`
      {
        color: ${this.props.color} !important;
        padding-left: 2px !important;
        font-weight: bold;
        font-size: 120%;
      }
    `;

    const Ast = () => {

      return (<ColorThemeHoverSpan>*</ColorThemeHoverSpan>);
    };

    return (
      <div>
        <h3 style={{marginTop: '20px'}}>Question about your Results?</h3>
        {
          this.state.error && (<p className="error" style={{color: '#900', fontWeight: 'bolder'}}>{this.state.error}</p>)
        }
        {
          this.state.success && (<p className="success" style={{color: '#900', fontWeight: 'bolder'}}>{this.state.success}</p>)
        }
        {this.state.showForm &&
        <div>
          <form method="post" id="questions_form" action="http://www.raceresults360.com/widget/json.php"
                onSubmit={this.handleQuestionSubmit.bind(this)}>
            <table className="table-question" border="0" cellSpacing="0" cellPadding="0">
              <thead/>
              <tbody>
              <tr>
                <th><label htmlFor="name">Name<Ast />:</label></th>
                <td><input type="text" id="name" name="question_name" className="text" value={this.state.name}
                           onChange={this.handleOnChange.bind(this, 'name')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="email">Email<Ast />:</label></th>
                <td><input type="text" id="email" name="question_email" className="text" value={this.state.email}
                           onChange={this.handleOnChange.bind(this, 'email')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="gender">Gender<Ast />:</label></th>
                <td><select name="gender" id="gender" value={this.state.gender}
                            onChange={this.handleOnChange.bind(this, 'gender')}>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select></td>
              </tr>
              <tr>
                <th><label htmlFor="age">Age<Ast />:</label></th>
                <td><input type="text" id="age" name="age" className="text" value={this.state.age}
                           onChange={this.handleOnChange.bind(this, 'age')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="city">City<Ast />:</label></th>
                <td><input type="text" id="city" name="city" className="text" value={this.state.city}
                           onChange={this.handleOnChange.bind(this, 'city')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="state">State<ast />:</label></th>
                <td><input type="text" id="state" name="state" className="text" value={this.state.state}
                           onChange={this.handleOnChange.bind(this, 'state')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="bib">Bib:</label></th>
                <td><input type="text" id="bib" name="bib" className="text" value={this.state.bib}
                           onChange={this.handleOnChange.bind(this, 'bib')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="clock">Clock Time (HH:MM:SS):</label></th>
                <td><input type="text" id="clock" name="clock" className="text" value={this.state.clock}
                           onChange={this.handleOnChange.bind(this, 'clock')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="finish">Finish Time (HH:MM:SS)<Ast />:</label></th>
                <td><input type="text" id="finish" name="finish" className="text" value={this.state.finish}
                           onChange={this.handleOnChange.bind(this, 'finish')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="chip">Chip Location (i.e. shoe, bib, wrist, pocket):</label></th>
                <td><input type="text" id="chip" name="chip" className="text" value={this.state.chip}
                           onChange={this.handleOnChange.bind(this, 'chip')}/></td>
              </tr>
              <tr>
                <th><label htmlFor="question">Question<Ast />:</label></th>
                <td><textarea type="text" id="question" name="question" cols="30" rows="4"
                              onChange={this.handleOnChange.bind(this, 'question')}>{this.state.question}</textarea>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="buttonwrap">
                  <input type="hidden" name="page" value="questions"/>
                  <input type="submit" name="submit_question" value="Submit"/>
                </td>
              </tr>
              </tbody>
            </table>
          </form>
        </div>
        }
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    favorites: state.rr360.favorites,
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId,
    color: state.rr360.theme.primaryColor
  };
}

export default connect(mapStateToProps, {toggleFavorite, submitQuestion})(Question);



// WEBPACK FOOTER //
// ./src/components/Question.js